export const useNotification = () => {
	const toast = useToast()
	const notification = useState<NotificationContext | null>('Notification')
	const clear = () => {
		notification.value = null
	}
	const alert = (arg: { status: number; message: string; title?: string }) => {
		useTimeouts(100).then(() => {
			notification.value = {
				notificationStatus: arg.status,
				notificationMessage: arg.message,
				notificationTitle: arg?.title ?? ''
			}
			if (notification.value) {
				if (Number(notification.value.notificationStatus) > 300) {
					toast.add({
						title: notification.value?.notificationTitle ?? '',
						description: notification.value?.notificationMessage ?? '',
						color: 'error'
					})
				} else if (Number(notification.value.notificationStatus) === 300) {
					toast.add({
						title: notification.value?.notificationTitle ?? '',
						description: notification.value?.notificationMessage ?? '',
						color: 'warning'
					})
				} else {
					toast.add({
						title: notification.value?.notificationTitle ?? '',
						description: notification.value?.notificationMessage ?? '',
						color: 'success'
					})
				}
			}
		})
	}
	return {
		clear,
		alert
	}
}
